import { useTranslation as usePublicI18n } from "react-i18next";
import { publicText, publicTemplate } from "./publicText";
import React, { useEffect } from "react";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import "./public.css";
function PublicLayout({
  children
}) {
  usePublicI18n();
  useEffect(() => {
    document.documentElement.classList.add("public-page-active");
    document.body.classList.add("public-page-active");
    return () => {
      document.documentElement.classList.remove("public-page-active");
      document.body.classList.remove("public-page-active");
    };
  }, []);
  return <div className="public-site">
      <PublicHeader />
      <main className="public-main">{publicText(children)}</main>
      <PublicFooter />
    </div>;
}
export default PublicLayout;
